"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _emojiMart = require("emoji-mart");

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Emoji = _interopRequireDefault(require("./Emoji.style"));

var _dec, _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let Emoji = (_dec = (0, _reactJss.default)(_Emoji.default), _dec(_class = (0, _reactClickOutside.default)(_class = class Emoji extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPicker: false,
      pickerOffset: 24
    };
    this.showPicker = this.showPicker.bind(this);
    this.handleChange = this.handleChange.bind(this);
  } // Get EmojiMart settings ot get default settings


  getEmojiProps() {
    const {
      emojiMart
    } = this.props;
    if (emojiMart) return emojiMart;
    return {
      set: 'apple',
      sheetSize: 32,
      showPreview: false
    };
  } // Handler for click outside of component


  handleClickOutside(e) {
    if (this.emojiBox && this.emojiBox.contains(e.target)) return;
    this.setState({
      showPicker: false
    });
  }

  handleChange(value) {
    const {
      id,
      onChange
    } = this.props;
    onChange({
      id,
      value,
      error: false
    });
  } // Show emoji picker


  showPicker() {
    const {
      visibility
    } = this.props;
    if (visibility !== 'visible') return;
    const pickerOffset = this.calcPickerPosition();
    this.setState({
      showPicker: true,
      pickerOffset
    });
  } // Calculate picker position


  calcPickerPosition() {
    const pickerHeight = 321;
    const pickerMargin = 8;
    const emojiBoxOffsetTop = this.emojiBox.getBoundingClientRect().top;
    let top = this.icon.offsetWidth + pickerMargin;

    if (window.innerHeight - emojiBoxOffsetTop < pickerHeight + pickerMargin) {
      top = -(pickerHeight + pickerMargin);
    }

    return top;
  }

  render() {
    const {
      classes,
      className,
      id,
      size,
      visibility
    } = this.props;
    const {
      showPicker,
      pickerOffset
    } = this.state;
    const emClasses = (0, _clsx.default)(className, classes.emoji, classes[size], {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    });
    const emojiProps = this.getEmojiProps();
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: el => this.emojiBox = el,
      id: id,
      className: emClasses,
      onClick: this.showPicker
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      forwardRef: el => this.icon = el,
      type: "smile",
      size: size
    }), showPicker ? /*#__PURE__*/_react.default.createElement("div", {
      className: classes.picker,
      style: {
        top: pickerOffset
      }
    }, /*#__PURE__*/_react.default.createElement(_emojiMart.Picker, (0, _extends2.default)({}, emojiProps, {
      onSelect: this.handleChange
    }))) : null);
  }

}) || _class) || _class);
Emoji.defaultProps = {
  visibility: 'visible',
  size: 'large',
  onChange: () => {}
};
var _default = Emoji;
exports.default = _default;